import requestFunctions from "../../functions/requestFunctions";


export const state = {
  SALES_ITEM: {},
  SALES_LIST: [],
  SALES_TABLE_DATA: [],
  SALES_TABLE_PRODUCTS_DATA: [],
  SALES_ARRAY_DATA: [],
  SALES_TOTAL_ROWS: 0
}

export const getters = {
  GET_SALES_ITEM: (state) => {
    return state.SALES_ITEM;
  },
  GET_SALES_LIST: (state) => {
    return state.SALES_LIST;
  },
  GET_SALES_TABLE_DATA: (state) => {
    return state.SALES_TABLE_DATA;
  },
  GET_SALES_TABLE_PRODUCTS_DATA: (state) => {
    return state.SALES_TABLE_PRODUCTS_DATA;
  },
  GET_SALES_ARRAY_DATA: (state) => {
    return state.SALES_ARRAY_DATA;
  },
  GET_SALES_TOTAL_ROWS: (state) => {
    return state.SALES_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_SALES_ITEM(state, item) {
    state.SALES_ITEM = item;
  },

  UPDATE_SALES_TABLE_PRODUCTS_DATA(state, list) {

    list = list.data;

    state.SALES_TABLE_PRODUCTS_DATA = [];

    list.forEach(el => {
      state.SALES_TABLE_PRODUCTS_DATA.push({
        'uuid'  : el.uuid,
        'fl_set': el.fl_set,
        'set_product_id': el.set_product_id,
        'product_name': el.product_name,
        'product_uuid': el.product_uuid,
        'product_id'  : el.product_id,
        'qnt' : el.qnt,
        'cost': el.cost,
        'sum' : el.sum,
        'unit_name' : el.unit_name,
        'unit_code' : el.unit_code,
        'created_at': el.created_at,
        'updated_at': el.updated_at,
      });
    });

  },

  UPDATE_SALES_LIST(state, list) {
    
    state.SALES_LIST = list.data;

    state.SALES_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.SALES_TABLE_DATA = [];
    state.SALES_ARRAY_DATA = [];

    list.forEach(el => {

      let status = {
        'draft'  : 'Черновик',
        'closed' : 'Закрыт',
        'check'  : 'Проверить'
      }

      state.SALES_TABLE_DATA.push({
        'uuid'   : el.uuid,
        'id'     : el.id,
        'number' : el.number,
        'document_date' : el.document_date,
        'sum'    : el.sum,
        'client_type' : el.client_type,
        'counterparty_name' : el.counterparty_name,
        'marketplace_name'  : el.marketplace_name,
        'shop_name'     : el.shop_name,
        'company_name'  : el.company_name,
        'warehouse_name': el.warehouse_name,
        'status': status[el.status] ? status[el.status] : '',
        'comments' : el.comments,
        'created_at'   : el.created_at,
        'updated_at'   : el.updated_at,
      });

      state.SALES_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
        number: el.id,
        sum: el.id,
      });
    });
  },
}

export const actions = {

  async FETCH_SALES_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/sales/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_SALES_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_SALES_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/sales';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_SALES_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_SALES_LIST_PRODUCTS({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/sales/' + payload.uuid + '/products';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_SALES_TABLE_PRODUCTS_DATA', response.data);
      return response.data;
    }
  },

  async FETCH_SALES_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/sales';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_SALES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/sales/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_SALES_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/sales/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}